// TODO: use mutation
import useOptimisticQuery from '../../hooks/useOptimisticQuery'
import axios from '../../utils/axios'
import { API_BASE_URL, HPO_MAP } from '../../constants'

export const updateHpo = async (fileId, hpoIdList) => {
  const { data } = await axios.patch(`${API_BASE_URL}/vcf/${fileId}/hpo`, {
    file_id: fileId,
    hpo_id_list: [],
    hpo_list_with_user_data: hpoIdList,
  })

  return data
}

/**
 * Format HPO terms with user metadata for saving to database
 * @param {Array} hpoTerms - Array of HPO term objects from HPOFilterWrapper
 * @param {Object} user - User object with first_name and last_name
 * @returns {Array} Formatted array of HPO terms with user metadata
 */
export const formatHpoWithUserData = (hpoTerms, user = {}) => {
  if (!hpoTerms || !Array.isArray(hpoTerms) || hpoTerms.length === 0) {
    return []
  }

  const firstName = user.first_name || ''
  const lastName = user.last_name || ''
  const timestamp = new Date().toISOString()

  return hpoTerms.map((term) => {
    // Handle both formatted terms (from HPOFilter) and raw terms
    const hpoId = term.hpo_id || term.value || term.hpo_id
    const termName = term.name || term.label
    const label = term.label || `${termName} (${hpoId})`

    return {
      label: label,
      value: hpoId,
      firstName: firstName,
      lastName: lastName,
      timestamp: timestamp,
      association: null,
    }
  })
}

const fetchHpo = async (fileId) => {
  const { data } = await axios.get(`${API_BASE_URL}/vcf/${fileId}/hpo`, {
    file_id: fileId,
  })
  return data
}

export const useHpo = ({ fileId }) => {
  const [hpoIdList = [], setHpoIdList] = useOptimisticQuery({
    queryKey: ['hpo-id-list', fileId],
    queryFn: () => fetchHpo(fileId),
    mutationFn: (hpoIdList) => updateHpo(fileId, hpoIdList),
    delay: 0,
  })

  let hpoList = hpoIdList

  const setHpoList = (newHpoList) => {
    const newIds = newHpoList
    setHpoIdList(newIds)
  }

  return [hpoList, setHpoList]
}
